import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import styled from '@emotion/styled'

import { selectStoreMapUrl } from '../../../../flux/selectors/stores'
import { selectUserNearestStoreId } from '../../../../flux/selectors/user'

const StyledLink = styled.a(() => ({
  width: '100%',
  height: '100%',
  display: 'block',
}))

const LinkToNearestStore = ({ children }) => {
  const storeId = useSelector(selectUserNearestStoreId)
  const mapUrl = useSelector(selectStoreMapUrl(storeId))

  return mapUrl ? (
    <StyledLink href={mapUrl} target="_blank" rel="noopener noreferrer">
      { children }
    </StyledLink>
  ) : children
}

LinkToNearestStore.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]).isRequired,
}

LinkToNearestStore.displayName = 'LinkToNearestStore'
LinkToNearestStore.whyDidYouRender = true

export default LinkToNearestStore
